import { Component, OnInit,ViewChild,AfterViewChecked ,ElementRef} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Title }     from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SYSHdsdService } from './sys-hdsd.service';
import { SYSParamsService } from '../sys-params/sys-params.service';
import { HdsdFile, CheckRole } from './sys-hdsd';

var FileSaver = require('file-saver');
declare var jQuery:any;
@Component({    
    selector: 'sys-hdsd',
    templateUrl: './sys-hdsd.component.html',
    providers: [SYSHdsdService, SYSParamsService]
})
export class SYSHdsdComponent implements OnInit {

    @ViewChild('myForm') myForm;
    
    title:string = "Tài liệu hệ thống";
    listItems:HdsdFile[] = [];
    CheckVal:CheckRole;
    itemFile:HdsdFile;
    loaiTaiLieu:any[] = [];
    noticeMsg:string;
    modalFileMsg:string;
    modalConfirmMsg:string;
    fileList:any;
    editFlg:boolean = false;
    clickSubmitted:boolean = false;
    IsAdminMax: number;
    username: string;
    
    constructor(
        private auth: AuthService,
        private service: SYSHdsdService,
        private paramService: SYSParamsService,
        private router: Router,
        private titleService: Title) { }

    ngOnInit() {
        this.titleService.setTitle(this.title);
        this.GetListItems();
        this.Reset();
        this.CheckRole();

    }

    Reset() {
        this.itemFile = new HdsdFile();
        this.fileList = "";
        this.clickSubmitted = false;
    }

    CheckRole(){
        this.username = this.auth.user.TaiKhoan;
        this.service.CheckRole(this.username)
        .subscribe(
        (data) => {
            this.CheckVal = data;
            //console.log(data);
            this.IsAdminMax = this.CheckVal.Check;
        },
        er => {
            console.log(er);
        });
    }
    
    FileChange(event) {
        this.fileList = event.target.files;
    }

    Popup_Add() {
        this.editFlg = false;
        this.Reset();
        this.GetLoaiTaiLieu();
        this.modalFileMsg = "Thêm mới tài liệu";
        jQuery("#modalFile").modal({backdrop: 'static', keyboard: true});
        (<HTMLInputElement>document.getElementById('FileUpload')).value = null;
    }//Popup_Add

    Popup_Edit(item:HdsdFile) {
        this.editFlg = true;
        this.Reset();
        this.GetItem(item.Ids);
        this.GetLoaiTaiLieu();
        this.modalFileMsg = "Chỉnh sửa tài liệu";
        jQuery("#modalFile").modal({backdrop: 'static', keyboard: true});
        (<HTMLInputElement>document.getElementById('FileUpload')).value = null;
    }//Popup_Edit

    Popup_Delete(item:HdsdFile) {
        this.GetItem(item.Ids);
        this.modalConfirmMsg = "Sẽ xóa tài liệu " + item.Ten + "?";
        jQuery("#modalConfirm").modal({backdrop: 'static', keyboard: true});
    }//Popup_Delete

    GetListItems() {
        this.service.GetListItems()
        .subscribe(
        (data) => {
            this.listItems = data;
            //console.log(data);
        },
        er => {
            console.log(er);
        });
    }//GetListItems

    GetItem(ids:string) {
        this.service.GetItem(ids)
        .subscribe(
        (data) => {
            this.itemFile = data;
        },
        er => {
            console.log(er);
        });
    }//GetListItems


    GetLoaiTaiLieu() {
        this.paramService.GetList("IdLoaiHDSD")
        .subscribe(
        (data) => {
            this.loaiTaiLieu = data;
        },
        er => {
            console.log(er);
        });
    }//GetLoaiTaiLieu

    DownloadFile(item:HdsdFile){
        jQuery("#loader").modal({backdrop: 'static', keyboard: true});
        this.service.DownloadFile(item)
        .subscribe(
        (data) => {            
            var blob = new Blob([data], {type: "application/octet-stream"});
            FileSaver.saveAs(blob, item.FileUpload);
            jQuery("#loader").modal("hide");
        },
        er => {
            console.log(er);
            jQuery("#loader").modal("hide");
            this.noticeMsg = "Xảy ra lỗi khi tải file xuống";
            jQuery("#modalNoti").modal({backdrop: 'static', keyboard: true});
        });
    }//DownloadFile

    Save(){
        this.clickSubmitted = true;
        if(!this.itemFile.Ten || !this.itemFile.Loai || (!this.editFlg && !this.fileList)) {
            return;
        }
        jQuery("#loader").modal({backdrop: 'static', keyboard: true});
        if (!this.editFlg) {
            this.SaveUploadFile();
        } else {
            if (!this.fileList) {
                this.SaveNoUploadFile();
            } else {
                this.SaveUploadFile();
            }
        }
        
        jQuery("#modalFile").modal("hide");
    }

    SaveUploadFile() {
        this.service.SaveUploadFile(this.fileList, this.itemFile)
        .subscribe((resp) => {
            if (resp.Success){
                this.GetListItems();
                jQuery("#loader").modal("hide");
                this.noticeMsg = "Lưu thành công";
                jQuery("#modalNoti").modal({backdrop: 'static', keyboard: true});
                //(<HTMLInputElement>document.getElementById('FileSelect')).value = null;
            }
            else{
                jQuery("#loader").modal("hide");
                this.noticeMsg = "Lưu thất bại! Chọn file không đúng định dạng";
                jQuery("#modalNoti").modal({backdrop: 'static', keyboard: true});
            }
        },
        (er) => {
            console.log(er);
            jQuery("#loader").modal("hide");
            this.noticeMsg = "Lưu thất bại";
            jQuery("#modalNoti").modal({backdrop: 'static', keyboard: true});
        });
    }

    SaveNoUploadFile() {
        this.service.SaveNoUploadFile(this.itemFile)
        .subscribe((resp) => {
            if (resp.Success){
                this.GetListItems();
                jQuery("#loader").modal("hide");
                this.noticeMsg = "Lưu thành công";
                jQuery("#modalNoti").modal({backdrop: 'static', keyboard: true});
            }
            else{
                jQuery("#loader").modal("hide");
                this.noticeMsg = "Lưu thất bại";
                jQuery("#modalNoti").modal({backdrop: 'static', keyboard: true});
            }
        },
        (er) => {
            console.log(er);
            jQuery("#loader").modal("hide");
            this.noticeMsg = "Lưu thất bại";
            jQuery("#modalNoti").modal({backdrop: 'static', keyboard: true});
        });
    }

    DeleteFile() {
        jQuery("#loader").modal({backdrop: 'static', keyboard: true});
        this.itemFile.TrangThai = false;
        this.service.SaveNoUploadFile(this.itemFile)
        .subscribe((resp) => {
            if (resp.Success){
                this.GetListItems();
                jQuery("#loader").modal("hide");
                this.noticeMsg = "Lưu thành công";
                jQuery("#modalNoti").modal({backdrop: 'static', keyboard: true});
            }
            else{
                jQuery("#loader").modal("hide");
                this.noticeMsg = "Lưu thất bại";
                jQuery("#modalNoti").modal({backdrop: 'static', keyboard: true});
            }
        },
        (er) => {
            console.log(er);
            jQuery("#loader").modal("hide");
            this.noticeMsg = "Lưu thất bại";
            jQuery("#modalNoti").modal({backdrop: 'static', keyboard: true});
        });
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/sys-hdsd/sys-hdsd.component.ts